import { render, staticRenderFns } from "./product-tags.vue?vue&type=template&id=de4d2ab6&scoped=true"
import script from "./product-tags.vue?vue&type=script&lang=ts&setup=true"
export * from "./product-tags.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./product-tags.vue?vue&type=style&index=0&id=de4d2ab6&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de4d2ab6",
  null
  
)

export default component.exports